import { createContext, ReactNode, useContext, useEffect, useMemo } from "react"
import { CsrfTokenErrorPage } from "./CsrfTokenErrorPage"
import {
  expireInvalidCsrfTokenReloadCount,
  getInvalidCsrfTokenReloadCount,
} from "./utils/invalidCsrfTokenReloadCountUtils"

const CsrfContext = createContext<string | null>(null)

export const useCsrfContext = () => {
  const context = useContext(CsrfContext)

  if (!context) throw new Error("useCsrfContext must be called within CsrfContextProvider")

  return context
}

export const CsrfContextProvider = ({
  children,
}: {
  children: (csrfToken: string | null) => ReactNode
}) => {
  const invalidCsrfTokenReloadCount = useMemo(getInvalidCsrfTokenReloadCount, [])
  const csrfToken =
    document.querySelector("meta[name='csrf-token']")?.attributes.getNamedItem("content")?.value ||
    null

  useEffect(() => {
    expireInvalidCsrfTokenReloadCount()
  }, [])

  if (invalidCsrfTokenReloadCount.value > 1) return <CsrfTokenErrorPage />

  return <CsrfContext.Provider value={csrfToken}>{children(csrfToken)}</CsrfContext.Provider>
}
